import URLConfig from './URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();

// The signed-in customer's profile: onboarding, address/phone, plus the staff "delete customer" action.
class ProfileService {

    getUserPreference() {
        return axiosInstance().get(path + "/shop/account/preference");
    }

    updateUserTypeDb(type) {
        return axiosInstance().post(path + "/shop/account/userType?userType=" + type);
    }

    updateUserPreferences(formData) {
        let config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        return axiosInstance().put(path + "/shop/account/preference", formData, config);
    }

    updateUserType(type) {
        localStorage.setItem('user_type', type)
    }

    isUserConfirmed() {
        return axiosInstance().get(path + "/shop/account/isConfirmed");
    }

}

export default new ProfileService()
